import * as _ from "lodash";
import * as angular from "angular";
import { Issue } from "../../../models/issue.model";
import { DialogUtils } from "../../../helper/dialog.helper";

let IssueReminderComponent = {
    selector: "vcIssueReminder",
    templateUrl:
        "/angular/components/issue/modals/issue-reminder.component.html",
    bindings: {
        selectedIssue: "=",
    },
    controller: class IssueReminderController {
        // * bindings for typescript compiler *
        public selectedIssue: Issue;
        // ************************************

        private dialog: DialogUtils;

        public issue: Issue;
        public reminder: any = {
            rmdatetime: new Date(),
            time: new Date(1970, 0, 1, 9, 0, 0),
        };
        private date = new Date();
        private minDate = new Date(
            this.date.getFullYear(),
            this.date.getMonth(),
            this.date.getDate()
        );
        private minTime: string = this.date.toTimeString().substring(0, 5);
        private sameDate = true;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        $onInit() {
            this.issue = _.cloneDeep(this.selectedIssue);
            this.setMinTime();
            this.reminder.time.setHours(this.minTime.substring(0, 2));
            this.reminder.time.setMinutes(this.minTime.substring(3, 5));
        }

        confirm(issue: Issue): void {
            this.reminder.csqid = issue.csqid;
            this.reminder.rmdatetime.setHours(this.reminder.time.getHours());
            this.reminder.rmdatetime.setMinutes(
                this.reminder.time.getMinutes()
            );
            this.reminder.rmdatetime.setSeconds(0);
            this.reminder.rmdatetime.setMilliseconds(0);

            this.dialog.hide(this.reminder);
        }

        cancel(): void {
            this.dialog.cancel();
        }

        setMinTime(): string {
            //grab the last digit from the time and parse to int for comparison
            let parsedLastTimeDigit = parseInt(this.minTime.slice(-1));
            if (parsedLastTimeDigit == 0 || parsedLastTimeDigit == 5) {
                return "";
            }
            if (parsedLastTimeDigit <= 4) {
                //grab everything but the last digit from the time string and replace with 5
                let timeMinusLastMinuteDigit = this.minTime.slice(0, -1);
                this.minTime = timeMinusLastMinuteDigit + "5";
            } else if (parsedLastTimeDigit >= 6) {
                //grab the second last digit of the time string and increment it by 1
                let incrementedMinute =
                    parseInt(this.minTime[this.minTime.length - 2]) + 1;

                //grab everything but the last two digits of the time string and suppliment with the incremented minute and 0 (10 or 20 etc)
                let timeMinusMinuteDigits = this.minTime.slice(0, -2);
                this.minTime = timeMinusMinuteDigits + `${incrementedMinute}0`;
            }
            return this.minTime;
        }

        setSameDate(date: any): void {
            this.sameDate = angular.equals(date, this.date) ? true : false;
            this.minTime = this.sameDate ? this.setMinTime() : "";
        }
    },
};

angular
    .module("issue")
    .component(IssueReminderComponent.selector, IssueReminderComponent);
